import { type TIntegrationCategory } from '../models/Unified';

export interface IDropdownButton {
    name: string;
    outline?: boolean;
    options: Array<{
        name: string;
        value?: string;
    }>;
}

export interface IMenuItem {
    name: string;
    link?: string;
    icon?: string;
    hint?: string;
    left_margin?: boolean;
    outline?: boolean;
    children?: Array<{
        name: string;
        link: string;
        border?: boolean;
        badge?: string;
    }>;
    sections?: Array<{
        title?: string;
        split?: number;
        items: Array<{
            name: string;
            link: string;
            border?: boolean;
            badge?: string;
        }>;
    }>;
}

export interface SwaggerPath {
    method?: string;
    path?: string;

    summary: string; // 'Get a list of authentication methods';
    operationId: string; // 'getAuthWorkspace_id';
    description?: string; // 'Once the user successfuly signs-in, a JWT parameter signed with your Workspace Secret will be sent to your success_redirect.  The decoded jwt (json web token) will be a IntegrationAuth object of the logged-in user.';
    parameters: {
        type: 'string' | 'number' | 'object' | string;
        description: string; // 'The ID of the workspace';
        pattern: string; // '^[0-9a-fA-F]{24}$';
        name: string; // 'workspace_id';
        in: 'path' | string;
        required: boolean;
        items: { enum: string[] };
        schema?: {
            $ref: string;
        };
    }[];
    tags?: TIntegrationCategory[];
    responses: {
        '200': {
            schema: {
                $ref?: string; //  '#/definitions/AuthIntegrations';
                type?: string;
                description?: string;
            };
            description: 'Successful';
        };
    };
    security?: any;
}

export interface SwaggerField {
    type?: 'boolean' | 'string' | 'number' | 'enum' | 'array' | 'object' | 'map';
    array?: boolean;
    format?: 'date' | string;
    description?: string;
    $ref?: string; // "#/definitions/ConnectionAuth"
    enum?: string[]; //  ['auth', 'crm', 'enrich', 'martech', 'ticketing', 'uc']; // when type = string
    in?: 'path' | 'query' | 'body';
    default?: string;
    required?: boolean;
    pattern?: string;
    name?: string;
    items?: SwaggerField;
    schema?: {
        $ref: string;
    };
    properties?: { [path in string]?: SwaggerField };
}
export interface SwaggerDefinition {
    array?: boolean;
    type: 'object' | 'array' | string;
    description?: string;
    items?: {
        [path in string]?: SwaggerField;
    };
    properties?: {
        [path in string]?: SwaggerField;
    };
    additionalProperties?: {
        $ref?: string;
        type?: string;
    };
    required?: string[]; //  ['workspaceId', 'integrationType', 'name', 'path', 'status', 'connectionId'];
    name?: string;
    tags?: string[];
}

export type SwaggerDefinitions = {
    [path in string]?: SwaggerDefinition;
};

export type SwaggerPaths = {
    [path in string]: SwaggerPath;
};

export interface SwaggerFile {
    definitions: SwaggerDefinitions;
    paths: {
        [path in string]?: SwaggerPaths;
    };
}

export let PLATFORM = 'node';
export const PLATFORMS = ['node sdk', 'node', 'java', 'go', 'python', 'php', 'ruby', 'shell'];

export function setPlatform(p: string) {
    console.log('setplatform', p);
    PLATFORM = p;
}

export function capitalize(str: string, all?: boolean) {
    const reg = all ? /([^\W_]+[^\s-]*) */g : /([^\W_]+[^\s-]*)/;
    return str ? str.replace(reg, fn) : '';

    function fn(txt: string) {
        return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
    }
}

export function isDev() {
    return process.env.NODE_ENV === 'development';
}

export function setTitle(title: string, desc?: string) {
    const data: any = {};
    if (desc) {
        data.meta = [
            {
                name: 'description',
                content: desc,
            },
        ];
    }

    if (title.includes('|')) {
        data.title = title;
    } else {
        data.title = `${title} | Unified`;
    }

    useHead(data);
}

const LIST = ['/null/pointer', '/stack/overflow', '/undefined/property', '/syntax/error', '/lost/octopus'];
export function notfound($router: any) {
    const index = Math.floor(Math.random() * LIST.length);
    const target = LIST[index];
    try {
        // Only log in dev or when localStorage debug flag is set
        const dev = isDev();
        const dbg = typeof window !== 'undefined' && localStorage.getItem('debug') === '1';
        if (dev || dbg) {
            console.warn('[notfound] redirecting to 404 path', { target });
        }
    } catch {}
    $router.push(target);
}

export function getArticle(word: string): 'a' | 'an' {
    return /^[aeiou]/i.test(word.trim()) ? 'an' : 'a';
}
